<div
  class="main-menu-wrapper zone-dark"
  @wrapperIn
  *ngIf="opened"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
>
  <div class="main-menu-bg" @bgInOut></div>
  <div class="main-menu">
    <nav>
      <ul>
        <ng-container *ngFor="let link of links; index as i">
          <ng-container [ngSwitch]="link.type">
            <ng-container *ngSwitchCase="'route'">
              <li @linksInOut *ngIf="isRoute(link)">
                <a [attr.data-test]="link.id" [routerLink]="link.route">{{ link.label }}</a>
              </li>
            </ng-container>

            <ng-container *ngSwitchCase="'link'">
              <li @linksInOut *ngIf="isLink(link)">
                <a
                  [href]="link.href"
                  [target]="link.target || '_blank'"
                  (click)="onLinkClick()"
                  >{{ link.label }}</a
                >
              </li>
            </ng-container>

            <ng-container *ngSwitchCase="'action'">
              <li @linksInOut *ngIf="isAction(link)">
                <a (click)="onActionClick(link)">{{ link.label }}</a>
              </li>
            </ng-container>
          </ng-container>
        </ng-container>
      </ul>
    </nav>
  </div>
</div>
